import PropTypes from "prop-types";
import { splitUnit } from "../units";

// Renders "50 KM/H" as 50 with the unit in <small>, matching how the app has always
// shown speeds. Pass it the output of formatSpeed / formatDistance.
const Measurement = ({ children }) => {
  if (!children) return null;

  const [value, unit] = splitUnit(children);

  return (
    <>
      {value}
      {unit && <small>{unit}</small>}
    </>
  );
};

Measurement.propTypes = {
  children: PropTypes.string,
};

export default Measurement;
